(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tab-banner"] && !window.DesignMode) return;
  try {
    
  class TabSystem {  
    constructor(container) {  
        this.tabs = container.querySelectorAll('.button-container .tab');  
        this.contents = container.querySelectorAll('.image-container .content');
        this.init();  
    }  

    init() {  
        this.tabs.forEach((button, index) => {  
            button.addEventListener('click', () => this.changeTab(button, index));
        });  
    }  

    changeTab(button, index) {  
        // 清除所有标签的活动状态  
        this.tabs.forEach(tab => {  
            tab.classList.remove('active');  
        });  
        // 隐藏所有内容  
        this.contents.forEach(content => {  
            content.style.display = 'none';  
        });  

        // 设置当前标签为活动状态  
        button.classList.add('active');  
        this.contents[index].style.display = 'block';  
    }  
}  

// 使用示例  
document.addEventListener('DOMContentLoaded', () => {  
    // 查找所有 container 元素并为每一个创建 TabSystem 实例  
    document.querySelectorAll('.container').forEach(container => {  
        new TabSystem(container);  
    });  
});

  } catch(e) { console.error(e); }
})();
})();
